import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { translate } from '@jsverse/transloco';
import { EnumErrorStates, ErrorObject } from '@inmoment/the-kitchen';

import { GroupService } from 'app/providers/semantria-api/group.service';
import { Project, ProjectService } from 'app/providers/storage-api/project.service';
import { StorageListResult } from 'app/providers/storage-api.service';
import { AlertService } from 'app/services/alert.service';
import { MatDialogRef } from 'app/services/dialog.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

import { generalNameValidator } from '../../../../utils/customValidators';

@EnableClassTelemetry()
@Component({
  selector: 'app-project-create',
  templateUrl: './project-create.component.html',
  styleUrls: ['./project-create.component.scss'],
  standalone: false,
})
export class ProjectCreateDialogComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  public name = '';
  public description: string;
  public isLoading = { projectList: false, confirm: false };
  public projectList: StorageListResult<Project> = {};
  public isVisible = false;
  public projectNameStatus: ErrorObject = { state: EnumErrorStates.SUCCESS, text: '' };

  constructor(
    private dialogRef: MatDialogRef<ProjectCreateDialogComponent>,
    private router: Router,
    private projectService: ProjectService,
    private groupService: GroupService,
    private alertService: AlertService
  ) {
    this.refresh();
  }

  ngOnInit() {
    this.isVisible = true;
  }

  public async refresh(): Promise<void> {
    if (!this.projectList.items) {
      this.isLoading.projectList = true;
      this.projectList = await this.projectService.getProjects();
      this.isLoading.projectList = false;
    }
  }

  public onValidateProjectName() {
    generalNameValidator(
      this.name,
      this.projectNameStatus,
      translate('project-create.project'),
      64,
      true,
      this.projectList.items.map((project) => project.name),
      false,
      [{ character: '"', name: translate('project-create.double-quotes') }]
    );
  }

  public cancel(): void {
    this.isVisible = false;
    this.dialogRef.close(false);
  }

  public canConfirm(): boolean {
    if (
      !this.name.length ||
      this.name.trim().length < 1 ||
      this.description?.length > 256 ||
      this.projectNameStatus.state !== EnumErrorStates.SUCCESS
    ) {
      return false;
    }

    if (this.isLoading.confirm) {
      return false;
    }

    return true;
  }

  public async confirm(): Promise<void> {
    this.isLoading.confirm = true;

    try {
      const groupId = this.groupService.getSelectedGroupId();
      const result = await this.projectService.createProject(
        this.name,
        this.description,
        null,
        null,
        groupId
      );
      this.alertService.showToast(translate('project-create.create-success', { name: this.name }));
      this.isVisible = false;
      this.dialogRef.close(true);
      const urlTree = this.router.createUrlTree([
        'groups',
        this.groupService.getSelectedGroupId(true),
        'projects',
        result.id,
      ]);
      window.location.href = this.router.serializeUrl(urlTree);
    } catch (error) {
      this.alertService.showErrorToast(translate('project-create.create-failed'), error);
      this.isVisible = false;
      this.dialogRef.close(true);
    }
  }
}
